import { Sheet, SheetRef } from 'react-modal-sheet';
import { selectIsCustomMobileOpened, selectSistemiByType, selectTab, selectTipo } from '../carrelloSelectors';
import { useCallback, useEffect, useRef, useState } from 'react';

import { CarrelloCombinazioni } from '../carrelloCombinazioni';
import { CarrelloTabEnum } from '../types';
import { selectErrori } from 'features/sport/components/sportTicket/sportTicketSelectors';
import { useTypedSelector } from 'lib/centralStore';
import useWindowSize from 'hooks/useWindowSize';

const INITIAL_SNAP = 2;
export const CarrelloSheet = () => {
  const tab = useTypedSelector(selectTab);
  const carrelloType = useTypedSelector(selectTipo);
  const [isSheetOpen, setIsSheetOpen] = useState(false);
  const [snapPoint, setSnapPoint] = useState<Array<number>>([1, 0.6, 0.4, 0.28]);
  const errori = useTypedSelector(selectErrori);

  const { isMobile } = useWindowSize();

  const sheetRef = useRef<SheetRef>(null);
  const sheetHeader = useRef<HTMLDivElement>(null);
  const prevSnapPoint = useRef<number | null>(null);
  const isCustomMobileInputOpened = useTypedSelector(selectIsCustomMobileOpened);
  const sistemi = useTypedSelector((state) => selectSistemiByType(state, carrelloType));
  const [carrelloFooterHeight, setCarrelloFooterHeight] = useState(0);

  useEffect(() => {
    const calculateFooterHeight = () => {
      let footerElement: HTMLDivElement | undefined;
      const footerElements = document.querySelectorAll('[class^="CarrelloFooterContainer"]');
      footerElements.forEach((element) => {
        if (element.getAttribute('data-carrello-footer-type') === carrelloType) {
          if (element.getBoundingClientRect().height !== 0) {
            footerElement = element as HTMLDivElement;
          }
        }
      });

      if (footerElement) {
        setCarrelloFooterHeight(footerElement.getBoundingClientRect().height);
        const resizeObserver = new ResizeObserver(() => {
          const height = footerElement?.getBoundingClientRect().height!;
          if (height > 0) {
            setCarrelloFooterHeight(height);
            setSnapPoint((prev) => {
              const newSnapPoint = [...prev];
              newSnapPoint[3] = height + 20;
              return newSnapPoint;
            });
          }
        });
        resizeObserver.observe(footerElement);
      }
    };

    const timeoutId = setTimeout(() => {
      calculateFooterHeight();
    }, 300);
    return () => clearTimeout(timeoutId);
  }, [carrelloFooterHeight, carrelloType, isSheetOpen]);

  useEffect(() => {
    setIsSheetOpen(tab === CarrelloTabEnum.Biglietto);
  }, [tab]);

  const resetSheetPosition = useCallback(
    (event?: MouseEvent | TouchEvent | PointerEvent) => {
      if (isCustomMobileInputOpened) {
        const sheetHeaderBottomDistance = sheetHeader.current
          ? window.innerHeight - sheetHeader.current.getBoundingClientRect().bottom
          : 0;
        if (prevSnapPoint.current === 0) return;
        if ((carrelloFooterHeight ?? 0) > sheetHeaderBottomDistance) {
          event?.preventDefault();
          if (prevSnapPoint.current !== 1) {
            sheetRef.current?.snapTo(1);
          }
        }
      }
      if (errori) {
      }
    },
    [carrelloFooterHeight, errori, isCustomMobileInputOpened]
  );

  useEffect(() => {
    resetSheetPosition();
  }, [isCustomMobileInputOpened, resetSheetPosition]);

  useEffect(() => {
    if (sheetRef.current && isMobile) {
      setIsSheetOpen(!!sistemi.length);
    }
  }, [isMobile, sistemi.length]);

  const preventsOnClose = () => {};
  const handleSnapChange = (snapIndex: number) => {
    if (prevSnapPoint.current !== snapIndex) {
      prevSnapPoint.current = snapIndex;
    }
  };

  return (
    <Sheet
      key={carrelloType}
      ref={sheetRef}
      isOpen={isSheetOpen}
      onSnap={handleSnapChange}
      onClose={preventsOnClose}
      onPanEnd={resetSheetPosition}
      onDragEnd={resetSheetPosition}
      mountPoint={document.getElementById('sheet-mount-point')!}
      snapPoints={snapPoint}
      initialSnap={INITIAL_SNAP}
      id="modal-sheet"
      dragVelocityThreshold={Infinity}
    >
      <Sheet.Container style={{ paddingBottom: `${carrelloFooterHeight}px`, zIndex: 9 }}>
        <Sheet.Header ref={sheetHeader} />
        <Sheet.Content disableDrag>
          <Sheet.Scroller draggableAt="top">
            <CarrelloCombinazioni />
          </Sheet.Scroller>
        </Sheet.Content>
      </Sheet.Container>
    </Sheet>
  );
};
